export default {
      id: "oc-aws-usage",
      viewBox: "0 0 1706 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-aws",
      toString: function () {
        return this.url;
      }
    }